<template>
  <ChatHistory />
</template>

<script>
import ChatHistory from '@/components/ChatHistory/index';

export default {
  components: {
    ChatHistory
  },
};
</script>

<style lang="scss" src="@/assets/scss/mystage_history.scss" />
<style lang="scss" src="@/assets/scss/mystage_history_sp.scss" />
<style lang="css" src="@/assets/css/style-print.css" media="print" />

<style lang="scss" scoped>
.header_right_side_contents {
  right: 144px;
}

.pointer-events-none {
  pointer-events: none;
}

:deep(.el-scrollbar__thumb) {
  background: #1287cd !important;
  border-radius: 0px;
  opacity: 1;
}

:deep(.el-scrollbar__bar) {
  right: 0px !important;
}

@media screen and (min-width: 960px) {
  .header_logo img {
    width: 102px;
    height: 24px;
  }
}

@media screen and (max-width: 959px) {
  .header_logo img {
    width: 76.5px;
    height: 18px;
  }
}

@media screen and (min-width: 960px) {
  .exit-dialog {
    float: right;
    top: 30px;
    right: 30px;
    margin: 0 !important;
    width: 380px;
  }

  .exit-dialog .el-dialog__footer {
    padding-bottom: 43px;
  }
}

@media screen and (max-width: 959px) {
  .exit-dialog {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    margin-top: 0 !important;
    width: 89%;
    height: 260px;
  }
}

@media screen and (max-width: 375px) {
  .exit-dialog {
    height: 265px;
  }

  .dialog-footer .exit-buttons {
    display: block;
    margin: 0 auto;
  }

  .dialog-footer .exit-buttons:last-child {
    margin-top: 4px !important;
  }
}
</style>